import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    Card,
    CardContent,
    Grid,
    Modal,
    TablePagination,
    MenuItem,
    Menu,
    IconButton,
    Radio, 
    RadioGroup, 
    FormControlLabel, 
    FormControl, 
    FormLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputAdornment,
    CircularProgress,
    Alert,
  } from "@mui/material";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { checkLoanEligibility, loanPayment, loanPaymentCancel, loanPaymentConfirmation7, postAdjustmentNoPin10 } from "../../util/API/loans";
import "./LoanPaymentsPage.scss";
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import LoanPaymentBreakdown from "../LoanPaymentBreakdown/LoanPaymentBreakdown";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import CustomLoansForm from "../UI/CustomLoansForm/CustomLoansForm";
import { useDispatch } from "react-redux";
import { setNewConstants } from "../../store/redux/constants";
import { getExternalAccountBalance, getExternalAccounts } from "../../util/API/externalaccounts";
import { LOANS_ACCOUNT_NO } from "../../config";

const LoanPaymentsPage = ({setPayments, setIsLoading, selectedProductLoan, selectedUser}) => {
    const [loanData, setLoanData] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [selectedLoan, setSelectedLoan] = useState(null);
    const [selectedLoanType, setSelectedLoanType] = useState(null);
    const [customAmount, setCustomAmount] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [alert, setAlert] = useState({
        showAlert: false,
        severity: "",
        header: "",
        message: "",
        onConfirm: null,
        alertType: ''
    });
    const [alertOpen, setAlertOpen] = useState(false);
    const [outstandingLoans, setOutstandingLoans] = useState([]);
    const [allOutstandingLoans, setAllOutstandingLoans] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [paymentType, setPaymentType] = useState("full");
    const [isGlobalPayment, setIsGlobalPayment] = useState(false);
    const [openLoanDetailsDrawer, setOpenLoanDetailsDrawer] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [formValues, setFormValues] = useState(null);
    const [userTransactionAccArr, setUserTransactionAccArr] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
    const [externalBalance, setExternalBalance] = useState(0);
    const [selectedUserAcc, setSelectedUserAcc] = useState(null);

    const dispatch = useDispatch();
    
    // Dummy Data to send to api
    const [sampleloantype, setSampleloantype] = useState(1);
    const [sampleloanamount, setSampleloanamount] = useState(1);
    const [sampleloanamountforfeecalculation, setSampleloanamountforfeecalculation] = useState(1);
    const [sampletermtype, setSampletermtype] = useState(0);
    const [refid, setRefid] = useState(1);
    const [returnoutstandingloans, setReturnoutstandingloans] = useState(1);
    const [intent, setIntent] = useState("");
    // =====================================================  //

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
        //   backgroundColor: 'rgba(0,0,0, .1)',
          color: theme.palette.common.black,
          fontWeight: 'bold',
        //   textAlign:"center",
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 25,
          fontWeight: '600'
        },
    }));

    useEffect(()=> {
        console.log("paymentSelectedProductLoan============",selectedProductLoan);
        getLoanProductInfo()
        getUserAccounts();
    },[selectedProductLoan])

    useEffect(() => {
    if (userTransactionAccArr.length > 0) {
        const formattedArr = userTransactionAccArr.map(item => ({
            key: item.Vuserpi3.id,
            value: item.Vuserpi3.id,
            label: item.Vuserpi3.friendlyname,
        }));
        dispatch(setNewConstants({ formSelectData: { useraccount: formattedArr } }));
        console.log("Dispatched user accounts to Redux:", formattedArr);
    }
}, [userTransactionAccArr, dispatch]);

    const getLoanProductInfo = async() => {
        try {
            let response = await checkLoanEligibility(
                "",
                selectedUser,
                selectedProductLoan?.productcode,
                sampleloantype,
                sampleloanamount,
                sampleloanamountforfeecalculation,
                sampletermtype,
                refid,
                returnoutstandingloans,
                intent
            );

            if (response?.data?.header?.callStatus === "1" && response?.data?.body?.outstandingloans?.outstandingloan !== "") {
                const loanProductsArray = Array.isArray(response?.data?.body?.outstandingloans?.outstandingloan) ? response?.data?.body?.outstandingloans?.outstandingloan : [response?.data?.body?.outstandingloans?.outstandingloan];
                console.log("getLoanProductInfo_loanProductsArray============",loanProductsArray);
                setLoanData(response?.data);
                setOutstandingLoans(loanProductsArray);
                setAllOutstandingLoans(loanProductsArray);
            } else {
                setOutstandingLoans([]);
                setAllOutstandingLoans([]);
                setLoanData(response?.data);
            }
        } catch (error) {
            console.log("getLoanProductInfo_error============",error);
        } 
    }

    const getUserAccounts = async() => {
        let response = await getExternalAccounts(selectedUser);
        console.log("getUserAccounts===============", response);
        let records = response.payload?.record;
        if (!records) return;
        if (!Array.isArray(records)) {
        records = [records];
        }
        // Separate transaction accounts from other accounts
        // const transactionAccounts = records.filter((account) =>
        //     account.Vuserpi3?.friendlyname?.toLowerCase().includes("transaction")
        // );

        setUserTransactionAccArr(records);
        //console.log("transactionAccounts===============", transactionAccounts);
        console.log("All accounts set:", records);
    }

    const handlePayment = async(loan, type) => {
        try {
            const amount = type === "full" ? loan?.outstandingamountwithlatefee : loan?.outstandinglatefees;
            const latefeesonly = type === "full" ? 0 : 1;
            const response = await loanPayment("", selectedUser, selectedProductLoan?.productcode, amount, 1, 0, loan?.loanid, latefeesonly, "");
            console.log("handlePayment_response============",response);
            if(response?.data?.header?.callStatus == "1") {
                setIsLoading(false)
                setAlert({
                    showAlert: true,
                    severity: "success",
                    message: "Loan amount paid successfully.",
                    header: "Congratulations!"
                });

                setSelectedLoan(null);
                getLoanProductInfo();
            }
        } catch (error) {
            console.log("handlePayment_error============",error);
        }
    }

    // Submit custom payment
    const handleCustomPayment = async(submittedData) => {
        try {
            setLoading(true);
            const latefeesonly = submittedData?.paymenttype === "late" ? 1 : 0;

            const matchedUser = userTransactionAccArr.find(user => user.Vuserpi3.id === submittedData.useraccount);

            console.log("submittedData============",submittedData);
            console.log("selectedLoan============",selectedLoan);
            console.log("customAmount============",customAmount);
            console.log("selectedLoan?.loanid============",selectedLoan?.loanid);
            console.log("userTransactionAccArr============",userTransactionAccArr);
            console.log("matchedUser============",matchedUser);

            let transactions = [
                {
                    accountnumber: matchedUser?.Vuserpi3?.acctID,
                    type: 1,  
                    amount: submittedData?.paymentamount,
                    transactiontype: 3,
                    negativebalanceallowed: 1,
                    positivebalanceallowed: 0,        
                },
                {
                    accountnumber: LOANS_ACCOUNT_NO,
                    type: 2,
                    amount: submittedData?.paymentamount,
                    transactiontype: 3,
                    negativebalanceallowed: 1,
                    positivebalanceallowed: 1,     
                }
            ];
            console.log("transactions============",transactions);

            let reason = "Loan Amount Repayment";

            const response = await postAdjustmentNoPin10(
                "", // location
                0, // fromuserid
                selectedUser, // touserid
                matchedUser?.Vuserpi3?.currcode, // currency
                transactions, // transactions
                reason, // reason
                "", // externalrefid
                0, // sourcepi
                matchedUser?.Vuserpi3?.piid, // targetpi
                0, // sourceuserpi
                matchedUser?.Vuserpi3?.id, // targetuserpi
                "", //clerkname
                3, // transtypeid
                matchedUser?.Vuserpi3?.acctID, //recipientaccountno
                "", // adminmsg
                0, // channelid
                selectedUser, //recipientuserid
                0, //parentuserid
            );
            
            console.log("handleCustomPayment_response============",response);

            // Handle Error
            if(response?.Status == '2') {
                console.log("handleCustomPayment_response============",response?.payload?.msg);
                setAlert({
                    showAlert: true,
                    severity: "error",
                    message: `Loan Payment Failed. ${response?.payload?.msg}`,
                    header: "Payment Failed!"
                });

                setExternalBalance(0);
                setSelectedUserAcc(null);

            } else if (response?.data?.header?.callStatus === "1") {
                const response2 = await loanPayment("", selectedUser, selectedProductLoan?.productcode, submittedData?.paymentamount, "", 0, selectedLoan ? selectedLoan?.loanid : 0, latefeesonly, selectedUser);
                // const response2 = await loanPayment("", 9999999, selectedProductLoan?.productcode, submittedData?.paymentamount, "", 0, selectedLoan ? selectedLoan?.loanid : 0, latefeesonly, selectedUser);

                // On LoanPayment22 API success
                if(response2?.data?.header?.callStatus === "1" && response2?.data?.header?.paymentid) {
                    console.log("LoanPayment22_response============",response2);
                    console.log("loanid============",response2?.data?.body?.LoansApplied?.LoanRecord?.loanid);
                    setTimeout(async()=> {
                        const response3 = await loanPaymentConfirmation7("", selectedUser, response2?.data?.header?.paymentid, "", "", response2?.data?.body?.LoansApplied?.LoanRecord?.loanid, matchedUser?.Vuserpi3?.currcode);
                        // const response3 = await loanPaymentConfirmation7("", selectedUser, 999999, "", "", response2?.data?.body?.LoansApplied?.LoanRecord?.loanid, matchedUser?.Vuserpi3?.currcode);
                        console.log("loanPaymentConfirmation7_response============",response3);
    
                        //  On loanPaymentConfirmation7 success
                        if(response3?.data?.header?.callStatus === "1") {
                            console.log("success============",response3);
                            if(response3?.data?.header?.callStatus == "1") {
                                if(parseInt(response2?.data?.header?.residualamount) > 0) {
                                    let transactions = [
                                        {
                                            accountnumber: LOANS_ACCOUNT_NO,
                                            type: 1,  
                                            amount: parseInt(response2?.data?.header?.residualamount),
                                            transactiontype: 1,
                                            negativebalanceallowed: 1,
                                            positivebalanceallowed: 1,        
                                        },
                                        {
                                            accountnumber: matchedUser?.Vuserpi3?.acctID,
                                            type: 2,
                                            amount: parseInt(response2?.data?.header?.residualamount),
                                            transactiontype: 1,
                                            negativebalanceallowed: 1,
                                            positivebalanceallowed: 0,     
                                        }
                                    ];

                                    let reason = "Residual Amount Deposited";
    
                                    const response7 = await postAdjustmentNoPin10(
                                        "", // location
                                        0, // fromuserid
                                        selectedUser, // touserid
                                        matchedUser?.Vuserpi3?.currcode, // currency
                                        transactions, // transactions
                                        reason, // reason
                                        "", // externalrefid
                                        0, // sourcepi
                                        matchedUser?.Vuserpi3?.piid, // targetpi
                                        0, // sourceuserpi
                                        matchedUser?.Vuserpi3?.id, // targetuserpi
                                        "", //clerkname
                                        3, // transtypeid
                                        matchedUser?.Vuserpi3?.acctID, //recipientaccountno
                                        "", // adminmsg
                                        0, // channelid
                                        selectedUser, //recipientuserid
                                        0, //parentuserid
                                    );
                
                                    console.log("Residual Amount Deposited Response=================", response7);
                                }

                                // setLoading(false);
                                setAlert({
                                    showAlert: true,
                                    severity: "success",
                                    message: "Loan amount paid successfully.",
                                    header: "Congratulations!"
                                });
                                setAlertOpen(true);
    
                                setPaymentType("full");
                                setSelectedLoan(null);
                                setExternalBalance(0);
                                setSelectedUserAcc(null);
                                getLoanProductInfo();
                            }
                        } else if(response3?.Status == '2') {
                            // If loanPaymentConfirmation7 api fails
                            console.log("failure============",response3);
                            const response4 = await loanPaymentCancel("", selectedUser, response2?.data?.header?.paymentid, "", "", 1, response2?.data?.body?.LoansApplied?.LoanRecord?.loanid, matchedUser?.Vuserpi3?.currcode, 0);
                            console.log("loanPaymentCancel_response4============",response4);
    
                            if(response4?.data?.header?.callStatus == "1") {
                                let transactions = [
                                    {
                                        accountnumber: LOANS_ACCOUNT_NO,
                                        type: 1,  
                                        amount: submittedData?.paymentamount,
                                        transactiontype: 1,
                                        negativebalanceallowed: 1,
                                        positivebalanceallowed: 1,        
                                    },
                                    {
                                        accountnumber: matchedUser?.Vuserpi3?.acctID,
                                        type: 2,
                                        amount: submittedData?.paymentamount,
                                        transactiontype: 1,
                                        negativebalanceallowed: 1,
                                        positivebalanceallowed: 0,     
                                    }
                                ];
    
                                let reason = "Loan Confirmation Failed - Amount Refunded";
    
                                const response5 = await postAdjustmentNoPin10(
                                    "", // location
                                    0, // fromuserid
                                    selectedUser, // touserid
                                    matchedUser?.Vuserpi3?.currcode, // currency
                                    transactions, // transactions
                                    reason, // reason
                                    "", // externalrefid
                                    0, // sourcepi
                                    matchedUser?.Vuserpi3?.piid, // targetpi
                                    0, // sourceuserpi
                                    matchedUser?.Vuserpi3?.id, // targetuserpi
                                    "", //clerkname
                                    3, // transtypeid
                                    matchedUser?.Vuserpi3?.acctID, //recipientaccountno
                                    "", // adminmsg
                                    0, // channelid
                                    selectedUser, //recipientuserid
                                    0, //parentuserid
                                );
            
                                setAlert({
                                    showAlert: true,
                                    severity: "error",
                                    message: `Loan Payment Failed. ${response3?.payload?.msg}`,
                                    header: "Payment Failed!"
                                });
                            }
                        }
                    }, 1000)
                } else {
                    // On LoanPayment22 API failure

                    let transactions = [
                        {
                            accountnumber: LOANS_ACCOUNT_NO,
                            type: 1,  
                            amount: submittedData?.paymentamount,
                            transactiontype: 1,
                            negativebalanceallowed: 1,
                            positivebalanceallowed: 1,        
                        },
                        {
                            accountnumber: matchedUser?.Vuserpi3?.acctID,
                            type: 2,
                            amount: submittedData?.paymentamount,
                            transactiontype: 1,
                            negativebalanceallowed: 1,
                            positivebalanceallowed: 0,     
                        }
                    ];

                    let reason = "Loan Payment Failed - Amount Refunded.";

                    const response6 = await postAdjustmentNoPin10(
                        "", // location
                        0, // fromuserid
                        selectedUser, // touserid
                        matchedUser?.Vuserpi3?.currcode, // currency
                        transactions, // transactions
                        reason, // reason
                        "", // externalrefid
                        0, // sourcepi
                        matchedUser?.Vuserpi3?.piid, // targetpi
                        0, // sourceuserpi
                        matchedUser?.Vuserpi3?.id, // targetuserpi
                        "", //clerkname
                        3, // transtypeid
                        matchedUser?.Vuserpi3?.acctID, //recipientaccountno
                        "", // adminmsg
                        0, // channelid
                        selectedUser, //recipientuserid
                        0, //parentuserid
                    );

                    if(response2?.Status == "2" && response2?.payload?.callStatus == "0") {
                        setAlert({
                            showAlert: true,
                            severity: "error",
                            message: `Loan Payment Failed. ${response2?.payload?.msg}`,
                            header: "Payment Failed!"
                        });
                    } else {
                        setAlert({
                            showAlert: true,
                            severity: "error",
                            message: `Loan Payment Failed. ${response6?.payload?.msg}`,
                            header: "Payment Failed!"
                        });
                    }

                }
            }

            setOpenModal(false);
            setCustomAmount("");
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        } catch (error) {
            setLoading(false);
            setOpenModal(false);
            console.log("handleCustomPayment_error============",error);
        } finally {
            // setLoading(false);
        }
    };

    // const handlePaymentConfirmation = (type, loan) => {
    //     if (type === "custom") {
    //         console.log("handlePaymentConfirmation---------------------",loan)
    //         setSelectedLoan(loan);
    //         setSelectedLoanType(loan);
    //         setOpenModal(true);
    //     } else {
    //         setAlert({
    //             ...alert,
    //             showAlert: true,
    //             message: `Are you sure you want to ${type === "full" ? "Pay Full Amount" : "Pay Only Late Fees"}`,
    //             severity: "confirm",
    //             header: "Please Confirm",
    //             alertType: 'confirm',
    //             onConfirm: () => {
    //                 handlePayment(loan, type);
    //             },
    //             // onConfirm: () => handlePayment(loan)
    //           })
    //         console.log(type === "full" ? "Pay Full Amount" : "Pay Only Late Fees", loan);
    //     }
    // };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedLoan(loan);
        setCustomAmount("");
        setPaymentType("full");
    };
    
    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
        // setSelectedLoan(null);
    };

    const handleModalRadioBtnChange = async(e) => {
        setPaymentType(e.target.value)
        console.log("handleModalRadioBtnChange_e------------",e.target.value)
        if(isGlobalPayment === true) {
            if(e.target.value === "full") {
                setCustomAmount(totalOutstandingAmount);
            } else {
                setCustomAmount(totalLateFees);
            }
        } else {
            if(e.target.value === "full") {
                setCustomAmount(selectedLoan?.outstandingamountwithlatefee);
            } else {
                setCustomAmount(selectedLoan?.outstandinglatefees);
            }
        }
    }
    
    const handleGlobalPayment = () => {
        try {
            setSelectedLoan(null);
            setIsGlobalPayment(true);
            setOpenModal(true);
            setCustomAmount(totalOutstandingAmount);
        } catch (error) {
            
        }
    }

    const handleSingleLoanPayment = async(loan) => {
        setSelectedLoan(loan)
        setPaymentType("full");
        setIsGlobalPayment(false);
        setCustomAmount(loan?.outstandingamountwithlatefee);
        setOpenModal(true);
    }

    const handlePaymentBreakdown = async(loan) => {
        console.log("handlePaymentBreakdown-------------",loan)
        setSelectedLoan(loan)
        setOpenLoanDetailsDrawer(true);
    }

    const handleSearch = async() => {
        if (!searchText.trim()) {
            setOutstandingLoans(allOutstandingLoans); // Reset to original data if search is cleared
            return;
        }
        const filteredLoans = allOutstandingLoans.filter((row) => {
            return (
                row?.totalamountissued.includes(searchText.toLowerCase()) ||
                row?.outstandingamountwithlatefee?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.totalamountpaid?.toString().includes(searchText) ||
                row?.outstandinglatefees?.toLowerCase().includes(searchText.toLowerCase())
            );
        });
        setOutstandingLoans(filteredLoans);
    }

    const handleInputChange = (e) => {
        setSearchText(e.target.value);
    }

    const handleViewDetails = (loan) => {
        setSelectedLoan(loan);
        // setOpenDetailsDialog(true);
        setOpenDetailsDrawer(true);
        handleMenuClose(); // close the menu
    };

    const totalOutstandingAmount = outstandingLoans.reduce(
        (sum, loan) => sum + parseFloat(loan.outstandingamountwithlatefee), 0
    );
    const totalLateFees = outstandingLoans.reduce(
        (sum, loan) => sum + parseFloat(loan.outstandinglatefees), 0
    );
    const totalAmountPaid = outstandingLoans.reduce(
        (sum, loan) => sum + parseFloat(loan.totalprinciplepaid), 0
    );
    const totalamountissued = outstandingLoans.reduce(
        (sum, loan) => sum + parseFloat(loan.totalamountissued), 0
    );

    const handleMakePaymentMenuClick = async() => {
        try {
            const formattedArr = userTransactionAccArr.map(item => ({
                key: item.Vuserpi3.id,
                value: item.Vuserpi3.id,
                label: item.Vuserpi3.friendlyname,
            }));
            dispatch(setNewConstants({ formSelectData: { useraccount: formattedArr } }));
        } catch (error) {
            console.log("handleMakePaymentMenuClick_error-----------",error)
        }
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setAlertOpen(false);
    };

    const getUserExternalAcctBalance = async(val) => {
        console.log("getUserExternalAcctBalance=================",val);
        let response = await getExternalAccountBalance(
          selectedUser,
          val
        );
        console.log("getUserExternalAcctBalance_res=====================",response);
        if(response?.Status == "2" && response?.payload?.balance) {
            let bal = response?.payload?.balance;
            bal = parseFloat(bal) * -1;
            bal = bal.toFixed(2);
            setExternalBalance(bal);
            setSelectedUserAcc(val);
        } else {
            setExternalBalance(0);
            setSelectedUserAcc(val);
        }
      }

    return (
        <>
            {loading ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            overflow: "hidden",
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                <Box className="loan-payment-container">
                    <Box className="d-flex justify-content-between">
                        <Typography
                            sx={{
                                fontFamily: "'Nunito'",
                                fontStyle: "normal",
                                fontWeight: 500,
                                fontSize: "21.4825px",
                                color: "#3A3A3A",
                            }}
                            className=""
                        >
                        Loan Payments
                        </Typography>
                        <Box>
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => setPayments(false)}
                        >
                            Return
                        </Button>
                        </Box>
                    </Box>

                    <Box>
                        <Box sx={{ flexShrink: 0, justifyContent:"center" }} className="mt-4">
                            <Grid container spacing={1}>
                            {[
                                { label: "Total Amount Issued", value: totalamountissued.toFixed(2) },
                                { label: "Total Outstanding Amount", value: totalOutstandingAmount.toFixed(2) },
                                { label: "Total Principal Paid", value: totalAmountPaid.toFixed(2) },
                                { label: "Total Late Fees", value: totalLateFees.toFixed(2) },
                            ].map((item, index) => (
                                <Grid item xs={12} sm={6} md={3} key={index}>
                                    <Box
                                        sx={{
                                            padding: "6px",
                                            border: "1px solid #ccc",
                                            borderRadius: "5px",
                                            backgroundColor: "#f9f9f9",
                                        }}
                                    >
                                        <Typography variant="caption" sx={{ fontWeight: "bold", fontSize:"14px" }}>
                                        {item.label}
                                        </Typography>
                                        <Typography variant="body1" sx={{ fontSize:"14px" }}>{item.value}</Typography>
                                    </Box>
                                </Grid>
                            ))}
                            </Grid>
                        </Box>

                        <Box className="mt-4">
                            <Button
                                className="fs-size-12 paiy-green text-white"
                                variant="contained"
                                color="primary"
                                onClick={handleGlobalPayment}
                            >
                                Make Full Payment
                            </Button>
                        </Box>

                        <Box className="mt-4">
                            <Box className="search-container">
                                <TextField
                                    placeholder="Search amount, late fees, etc."
                                    value={searchText}
                                    onChange={handleInputChange}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            handleSearch(); 
                                        }
                                    }}
                                    variant="standard"
                                    fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                        sx: {
                                            borderRadius: "33px",
                                            color: "#000",
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={handleSearch} edge="end">
                                                    <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={{
                                        "& .MuiInputBase-root": {},
                                        "& .MuiInputBase-input": {
                                            fontSize: "14px",
                                        },
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* Pay All Loans Section */}
                        {/* {outstandingLoans?.length > 0 && (
                            <Box mt={3} textAlign="center">
                                <Typography variant="h6">Make Payment for All Loans</Typography>
                                <TextField
                                    type="number"
                                    fullWidth
                                    placeholder="Enter total payment amount"
                                    size="small"
                                    sx={{ my: 2, maxWidth: 300 }}
                                />
                                <Box>
                                    <Button variant="contained" color="primary" sx={{ mx: 1 }}>
                                    Pay Full Amount
                                    </Button>
                                    <Button variant="contained" color="secondary" sx={{ mx: 1 }}>
                                    Pay Late Fees
                                    </Button>
                                </Box>
                            </Box>
                        )} */}
                    </Box>

                    <Box className="mt-4">
                        <TableContainer sx={{ marginTop: 2 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="right">Amount Issued</StyledTableCell>
                                        <StyledTableCell align="right">Outstanding Amount</StyledTableCell>
                                        <StyledTableCell align="right">Total Amount Paid</StyledTableCell>
                                        <StyledTableCell align="right">Late Fees</StyledTableCell>
                                        <StyledTableCell align="center">Payment Options</StyledTableCell>
                                        
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {outstandingLoans?.length > 0 ? outstandingLoans?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((loan) => (
                                        <TableRow key={loan.loanid}>
                                            {/* <TableCell className="payments-table-headers">{loan?.loanid}</TableCell> */}
                                            <TableCell align="right" className="payments-table-headers">{Number(loan?.totalamountissued).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                            <TableCell align="right" className="payments-table-headers">{Number(loan?.outstandingamountwithlatefee).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                            <TableCell align="right" className="payments-table-headers">{Number(loan?.totalamountpaid).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                            <TableCell align="right" className="payments-table-headers">{Number(loan?.outstandinglatefees).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                            {/* <TableCell className="payments-table-headers">
                                                <Button onClick={() => handleSingleLoanPayment(loan)} variant="contained" color="primary" sx={{ marginRight: 1 }}>Make Payment</Button>
                                            </TableCell> */}
                                            <TableCell align="center">
                                                <IconButton onClick={(e) => handleMenuOpen(e, loan)}>
                                                    <MoreVertIcon />
                                                </IconButton>
                                            </TableCell>
                                            {/* <TableCell className="payments-table-headers">
                                                <Button onClick={() => handlePaymentConfirmation("full", loan)} variant="contained" color="primary" sx={{ marginRight: 1 }}>Pay Full</Button>
                                                <Button onClick={() => handlePaymentConfirmation("late", loan)} disabled={loan.outstandinglatefees > 0 ? false : true}  variant="contained" color="secondary" sx={{ marginRight: 1 }}>Pay Late Fees Only</Button>
                                                <Button onClick={() => handlePaymentConfirmation("custom", loan)} variant="contained" color="warning">Pay Custom</Button>
                                            </TableCell> */}
                                        </TableRow>
                                    )) : (
                                        <TableRow>
                                            <TableCell align="center" colSpan={5}>
                                                <Typography variant="body1" color="textSecondary">
                                                No data available
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <TablePagination
                            component="div"
                            count={outstandingLoans?.length}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={[5, 10, 25]}
                        />

                        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                            <MenuItem
                                disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                                onClick={() => {
                                    handleMakePaymentMenuClick();
                                    handleSingleLoanPayment(selectedLoan)
                                    handleMenuClose();
                                }}
                            >
                                Make Payment
                            </MenuItem>
                            <MenuItem
                                disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                                onClick={() => {
                                    handleViewDetails(selectedLoan)
                                    handleMenuClose();
                                }}
                            >
                                View Details
                            </MenuItem>
                        </Menu>
                    </Box>

                    <BaseDrawer
                        open={openLoanDetailsDrawer}
                        handleClose={() => setOpenLoanDetailsDrawer(false)}
                        height="85vh"
                    >
                        <LoanPaymentBreakdown selectedLoan={selectedLoan} />
                    </BaseDrawer>

                    {/* Modal for Custom Payment */}
                    <Modal open={openModal} onClose={() => setOpenModal(false)}>
                        <Box
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: 400,
                                bgcolor: "background.paper",
                                p: 3,
                                borderRadius: "10px",
                                boxShadow: 24,
                            }}
                        >
                            <Box className="d-flex justify-content-between">
                                {/* <Typography variant="h6" gutterBottom>
                                    Select Payment Type
                                </Typography> */}
                                <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                                    <IconButton onClick={() => setOpenModal(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            </Box>

                            {/* Radio Buttons for Selection */}
                            {/* <FormControl component="fieldset">
                                <RadioGroup
                                    row
                                    value={paymentType}
                                    onChange={handleModalRadioBtnChange}
                                    // onChange={(e) => setPaymentType(e.target.value)}
                                >
                                    <FormControlLabel value="full" control={<Radio />} label="Outstanding + Late Fees" disabled={selectedLoan?.outstandingamountwithlatefee <= 0}  />
                                    <FormControlLabel value="late" control={<Radio />} label="Late Fees Only" disabled={selectedLoan?.outstandinglatefees <= 0 || totalLateFees <= 0 } />
                                </RadioGroup>
                            </FormControl> */}

                            {/* Input Field for Amount */}
                            {/* <TextField
                                fullWidth
                                label="Amount"
                                type="number"
                                className="mt-2"
                                value={customAmount}
                                // onChange={(e) => setCustomAmount(e.target.value)}
                                onChange={(e) => {
                                    let value = parseFloat(e.target.value);
                                    
                                    if (isNaN(value) || value < 0) {
                                        value = ""; // Prevent negative values or NaN
                                    } else {
                                        if (paymentType === "full") {
                                            value = Math.min(value, isGlobalPayment ? totalOutstandingAmount : selectedLoan?.outstandingamountwithlatefee);
                                        } else if (paymentType === "late") {
                                            value = Math.min(value, selectedLoan?.outstandinglatefees);
                                        }
                                    }
                                    setCustomAmount(value);
                                }}
                                sx={{ mb: 2 }}
                            /> */}

                            {/* <Button variant="contained" color="primary" fullWidth onClick={handleCustomPayment}>
                                Submit Payment
                            </Button> */}

                            <CustomLoansForm
                                formValues={formValues}
                                formName={"selectpaymenttype"}
                                buttonText={"Submit"}
                                onSubmit={handleCustomPayment}
                                loadingButtonText={"Adding Card ..."}
                                isGlobalPayment={isGlobalPayment}
                                totalOutstandingAmount={totalOutstandingAmount}
                                selectedLoan={selectedLoan}
                                initialValues={{
                                    paymentamount: customAmount,
                                    paymenttype: "full",
                                    useraccount:selectedUserAcc
                                }}
                                totalLateFees={totalLateFees}
                                getUserExternalAcctBalance={getUserExternalAcctBalance}
                                externalBalance={externalBalance}
                            />
                        </Box>
                    </Modal>

                    {alert.severity !== "success" && 
                        <CustomAlert
                            severity={alert.severity}
                            show={alert.showAlert}
                            header={alert.header}
                            message={alert.message}
                            onClick={() => {
                                setAlert({ ...alert, showAlert: false });
                            }}
                            alertType={alert.alertType}
                            confirmButton={alert.onConfirm}
                            autoclose={alert.severity === "error" ? false : true}
                        />
                    } 

                    <Box className="snackbar-container">
                        {alert.severity == "success" && 
                            <Snackbar 
                                open={alertOpen} 
                                autoHideDuration={4000} 
                                onClose={handleClose} 
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                            >
                                <Alert
                                    onClose={handleClose}
                                    severity="success"
                                    variant="filled"
                                    sx={{ width: '100%' }}
                                    autoHideDuration={null}
                                >
                                    {alert.message}
                                </Alert>
                            </Snackbar>
                        }
                    </Box>

                    <div className="loans-details-info-drawer">
                        <BaseDrawer
                            open={openDetailsDrawer}
                            handleClose={() => setOpenDetailsDrawer(false)}
                            height="85vh"
                            className="loanProductInfoDrawer"
                            overflow="auto"
                        >
                            {selectedLoan && (
                                <Box>
                                    <Box className="user-accounts-tab">
                                        <Box className="balance-container">
                                            <Box className="row" display="flex" flexWrap="wrap" gap={4}>

                                                {/* Left Side - Loan Summary */}
                                                <Box flex={1} 
                                                    // flex={1} 
                                                    minWidth="330px" 
                                                    className="mb-4"
                                                >
                                                    <Typography
                                                        sx={{
                                                        fontWeight: 800,
                                                        color: "#6b7280",
                                                        fontFamily: "Nunito",
                                                        fontSize: "16px",
                                                        fontStyle: "normal",
                                                        }}
                                                    >
                                                        Loan Summary
                                                    </Typography>

                                                    {[
                                                        { label: "Loan ID", value: selectedLoan.loanid },
                                                        { label: "User ID", value: selectedLoan.userid },
                                                        { label: "Issued Date", value: selectedLoan.issueddate },
                                                        { label: "Currency", value: selectedLoan.currcode },
                                                        { label: "Fully Paid", value: selectedLoan.fullypaidind === "1" ? "Yes" : "No" },
                                                        { label: "Fee %", value: selectedLoan.feeperc },
                                                        { label: "Fixed Fee", value: selectedLoan.feefixed },
                                                        { label: "Fee Amount", value: selectedLoan.feeamount },
                                                        { label: "Tax %", value: selectedLoan.taxperc },
                                                        { label: "Tax Amount", value: selectedLoan.taxamount },
                                                        { label: "Total Fees Issued", value: selectedLoan.totalfeesissued },
                                                        { label: "Total Amount Issued", value: selectedLoan.totalamountissued },
                                                        { label: "Payment Target Date", value: selectedLoan.paymenttargetdate || "N/A" },
                                                    ].map(({ label, value }, index) => (
                                                        <Box className="info-container" key={index}>
                                                        <Box className="info-type">{label}:</Box>
                                                        <Box className="info-response">{value}</Box>
                                                        </Box>
                                                    ))}
                                                </Box>

                                                {/* Right Side - Payment & Outstanding */}
                                                <Box flex={1} 
                                                    // flex={1} 
                                                    minWidth="330px"
                                                >
                                                    <Typography
                                                        sx={{
                                                        fontWeight: 800,
                                                        color: "#6b7280",
                                                        fontFamily: "Nunito",
                                                        fontSize: "16px",
                                                        fontStyle: "normal",
                                                        }}
                                                    >
                                                        Payment & Outstanding
                                                    </Typography>

                                                    {[
                                                        { label: "Principal Paid", value: selectedLoan.totalprinciplepaid },
                                                        { label: "Fees Paid", value: selectedLoan.totalfeespaid },
                                                        { label: "Total Paid", value: selectedLoan.totalamountpaid },
                                                        { label: "Principal Outstanding", value: selectedLoan.totalprincinpleoutstanding },
                                                        { label: "Fees Outstanding", value: selectedLoan.totalfeesoutstanding },
                                                        { label: "Total Outstanding", value: selectedLoan.totalamountoutstanding },
                                                        { label: "Late Fees", value: selectedLoan.outstandinglatefees },
                                                        { label: "Due Date", value: selectedLoan.loanduedate || "N/A" },
                                                        { label: "Loan Due Amount", value: selectedLoan.loandueamount },
                                                        { label: "Loan Not Due Amount", value: selectedLoan.loannotdueamount },
                                                        { label: "With Late Fee", value: selectedLoan.outstandingamountwithlatefee },
                                                        { label: "System Fee Breakdown", value: selectedLoan.feesystembreakdownoutstanding },
                                                        { label: "External Fee Breakdown", value: selectedLoan.feeexternalbreakdownoutstanding },
                                                        { label: "Franchisee Fee Breakdown", value: selectedLoan.feefranchiseebreakdownoutstanding },
                                                    ].map(({ label, value }, index) => (
                                                        <Box className="info-container" key={index}>
                                                            <Box className="info-type">{label}:</Box>
                                                            <Box className="info-response">{value}</Box>
                                                        </Box>
                                                    ))}
                                                </Box>

                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                        </BaseDrawer>
                    </div>

                    {/* View Details Modal/Dialog */}
                    {/* <Dialog
                        open={openDetailsDialog}
                        onClose={() => setOpenDetailsDialog(false)}
                        fullWidth
                        maxWidth="md"
                        className="loans-dialog"
                    >
                        <DialogTitle>
                            <Box>
                                Loan Payment Details
                                <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                                    <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                        </DialogTitle>
                        <DialogContent dividers>
                            {selectedLoan && (
                                <Box>
                                    <Box className="user-accounts-tab">
                                        <Box className="balance-container">
                                            <Box className="row" display="flex" flexWrap="wrap" gap={4}>

                                                <Box flex={1} 
                                                    // flex={1} 
                                                    minWidth="330px" 
                                                    className="mb-4"
                                                >
                                                    <Typography
                                                        sx={{
                                                        fontWeight: 800,
                                                        color: "#6b7280",
                                                        fontFamily: "Nunito",
                                                        fontSize: "16px",
                                                        fontStyle: "normal",
                                                        }}
                                                    >
                                                        Loan Summary
                                                    </Typography>

                                                    {[
                                                        { label: "Loan ID", value: selectedLoan.loanid },
                                                        { label: "User ID", value: selectedLoan.userid },
                                                        { label: "Issued Date", value: selectedLoan.issueddate },
                                                        { label: "Currency", value: selectedLoan.currcode },
                                                        { label: "External Ref No", value: selectedLoan.externalrefno },
                                                        { label: "Fully Paid", value: selectedLoan.fullypaidind === "1" ? "Yes" : "No" },
                                                        { label: "Fee %", value: selectedLoan.feeperc },
                                                        { label: "Fixed Fee", value: selectedLoan.feefixed },
                                                        { label: "Fee Amount", value: selectedLoan.feeamount },
                                                        { label: "Tax %", value: selectedLoan.taxperc },
                                                        { label: "Tax Amount", value: selectedLoan.taxamount },
                                                        { label: "Total Fees Issued", value: selectedLoan.totalfeesissued },
                                                        { label: "Total Amount Issued", value: selectedLoan.totalamountissued },
                                                        { label: "Payment Target Date", value: selectedLoan.paymenttargetdate || "N/A" },
                                                    ].map(({ label, value }, index) => (
                                                        <Box className="info-container" key={index}>
                                                        <Box className="info-type">{label}:</Box>
                                                        <Box className="info-response">{value}</Box>
                                                        </Box>
                                                    ))}
                                                </Box>

                                                <Box flex={1} 
                                                    // flex={1} 
                                                    minWidth="330px"
                                                >
                                                    <Typography
                                                        sx={{
                                                        fontWeight: 800,
                                                        color: "#6b7280",
                                                        fontFamily: "Nunito",
                                                        fontSize: "16px",
                                                        fontStyle: "normal",
                                                        }}
                                                    >
                                                        Payment & Outstanding
                                                    </Typography>

                                                    {[
                                                        { label: "Principal Paid", value: selectedLoan.totalprinciplepaid },
                                                        { label: "Fees Paid", value: selectedLoan.totalfeespaid },
                                                        { label: "Total Paid", value: selectedLoan.totalamountpaid },
                                                        { label: "Principal Outstanding", value: selectedLoan.totalprincinpleoutstanding },
                                                        { label: "Fees Outstanding", value: selectedLoan.totalfeesoutstanding },
                                                        { label: "Total Outstanding", value: selectedLoan.totalamountoutstanding },
                                                        { label: "Late Fees", value: selectedLoan.outstandinglatefees },
                                                        { label: "Due Date", value: selectedLoan.loanduedate || "N/A" },
                                                        { label: "Loan Due Amount", value: selectedLoan.loandueamount },
                                                        { label: "Loan Not Due Amount", value: selectedLoan.loannotdueamount },
                                                        { label: "With Late Fee", value: selectedLoan.outstandingamountwithlatefee },
                                                        { label: "System Fee Breakdown", value: selectedLoan.feesystembreakdownoutstanding },
                                                        { label: "External Fee Breakdown", value: selectedLoan.feeexternalbreakdownoutstanding },
                                                        { label: "Franchisee Fee Breakdown", value: selectedLoan.feefranchiseebreakdownoutstanding },
                                                    ].map(({ label, value }, index) => (
                                                        <Box className="info-container" key={index}>
                                                            <Box className="info-type">{label}:</Box>
                                                            <Box className="info-response">{value}</Box>
                                                        </Box>
                                                    ))}
                                                </Box>

                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog> */}
                </Box>
            )}
        </>
    )
}

export default LoanPaymentsPage;